<template>
  <div class="mall-order-delivery">
    <MallCard v-if="!address.address">
      <div class="mall-order-delivery__head">
        <span class="mall-order-delivery__empty">등록된 배송지가 없어요.</span>
        <MallButton :label="'등록'" :type="'soft'" :size="'sm'" @click="$emit('change-click')" />
      </div>
    </MallCard>
    <MallCard v-else>
      <div class="mall-order-delivery__head">
        <MallTextBadge v-if="address.isDefault" :label="'기본'" :type="'blue'" />
        <span class="mall-order-delivery__name">{{ address.name }}</span>
        <MallButton
          class="mall-order-delivery__change"
          :label="'변경'"
          :type="'soft'"
          :size="'sm'"
          @click="$emit('change-click')"
        />
      </div>
      <div class="mall-order-delivery__address">
        <div>
          <span class="mall-order-delivery__line">{{ address.address }}</span>
          <span class="mall-order-delivery__line">{{ address.detailAddress }}</span>
        </div>
        <span class="mall-order-delivery__line">{{ address.zipCode }}</span>
      </div>
    </MallCard>

    <div class="mall-order-delivery__field">
      <MallSubTitle :label="'받는 분'" />
      <MallTextField
        :value="recipientName"
        :placeholder="'받으시는 분의 성함을 입력해 주세요.'"
        @input="$emit('recipient-name-input', $event)"
      />
    </div>

    <div class="mall-order-delivery__field">
      <MallSubTitle :label="'연락처'" />
      <MallTextField
        :value="recipientPhone"
        :inputmode="'numeric'"
        :placeholder="'연락 가능한 번호를 입력해 주세요.'"
        @input="$emit('recipient-phone-input', $event)"
      />
    </div>
  </div>
</template>

<script>
import MallButton from '@/components/new/atoms/MallButton.vue'
import MallCard from '@/components/new/atoms/MallCard.vue'
import MallSubTitle from '@/components/new/atoms/MallSubTitle.vue'
import MallTextBadge from '@/components/new/atoms/MallTextBadge.vue'
import MallTextField from '@/components/new/molecules/MallTextField.vue'

export default {
  name: 'MallOrderDelivery',
  components: {
    MallButton,
    MallCard,
    MallSubTitle,
    MallTextBadge,
    MallTextField,
  },
  props: {
    // { isDefault, name, address, detailAddress, zipCode } (address가 비어 있으면 배송지 없음 안내)
    address: {
      type: Object,
      required: true,
    },
    recipientName: {
      type: String,
      default: '',
    },
    recipientPhone: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.mall-order-delivery {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mall-order-delivery__head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mall-order-delivery__name {
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

/* 변경 버튼은 오른쪽 끝 */
.mall-order-delivery__change {
  margin-left: auto;
}

.mall-order-delivery__address {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.mall-order-delivery__empty {
  flex: 1;
  color: #8B95A1;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-order-delivery__line {
  display: block;
}

.mall-order-delivery__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallOrderDelivery.vue